import {
  GETSALESORDERSDETAILS,
  CREATESALESORDERS,
  GETSALESORDERS,
  DELETESALESORDERS,
  UPDATESALESORDERS,
  CREATESALESORDERSITEM,
  CREATESALESORDERSREFRENCE,
  GETALLSALESORDERSDATA,
  UPDATESALESORDERSITEM,
  GETALLLOGESALESORDERSDATA,
  GETPRODUCTPACKAGERELATION,
  UPDATESALESITEM,
  CREATESALESORDERRECIPT,
  DELETELOGESALESITEM,
  UPDATELOGESALESITEM,
  CREATEREVERSESALESORDERS,
  UPDATEBULKMODULECHILREN,
  DELETELOGESALESITEMBYID,
} from "../actions/types";
const initialState = {
  salesordersList: [],
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATESALESORDERS:
      return {
        ...state,
        salesordersSaveStatus: action.payload.success,
      };
    case GETSALESORDERS:
      return {
        ...state,
        salesordersList: action.payload.data,
      };
    case GETSALESORDERSDETAILS:
      return {
        ...state,
        SalesOrderDetailsList: action.payload.data,
      };
    case UPDATESALESORDERS:
      return {
        ...state,
        salesordersUpdateStatus: action.payload.success,
      };

    case UPDATELOGESALESITEM:
      return {
        ...state,
        logesalesitemUpdateStatus: action.payload.success,
      };

    case DELETELOGESALESITEM:
      return {
        ...state,
        logesalesitemDeleteStatus: action.payload.success,
      };

    case DELETESALESORDERS:
      return {
        ...state,
        salesordersDeleteStatus: action.payload.success,
      };
    case CREATESALESORDERSITEM:
      return {
        ...state,
        salesordersItemSaveStatus: action.payload.success,
      };
    case UPDATESALESORDERSITEM:
      return {
        ...state,
        salesordersItemUpdateStatus: action.payload.success,
      };
    case CREATESALESORDERSREFRENCE:
      return {
        ...state,
        salesordersItemrefSaveStatus: action.payload.success,
      };

    case GETALLSALESORDERSDATA:
      return {
        ...state,
        AllSalesordersList: action.payload.data,
      };

    case GETALLLOGESALESORDERSDATA:
      return {
        ...state,
        logesalesorderdataList: action.payload.data,
      };

    case GETPRODUCTPACKAGERELATION:
      return {
        ...state,
        productpackagerelationList: action.payload.data,
      };
    case UPDATESALESITEM:
      return {
        ...state,
        salesordersItemUpdateStatus: action.payload.success,
      };

    case CREATESALESORDERRECIPT:
      return {
        ...state,
        salesordersReciptStatus: action.payload.success,
      };
    case CREATEREVERSESALESORDERS:
      return {
        ...state,
        salesordersReverseSaveStatus: action.payload.success,
      };
    case UPDATEBULKMODULECHILREN:
      return {
        ...state,
        bulkModuleChildUpdateStatus: action.payload.success,
      };
    case DELETELOGESALESITEMBYID:
      let updatedList = state.logesalesorderdataList;

      if (action.payload.success) {
        if (Array.isArray(state.logesalesorderdataList)) {
          updatedList = state.logesalesorderdataList.filter(
            (item) => String(item.id) !== String(action.payload.id),
          );
        } else if (
          state.logesalesorderdataList &&
          Array.isArray(state.logesalesorderdataList.data)
        ) {
          updatedList = {
            ...state.logesalesorderdataList,
            data: state.logesalesorderdataList.data.filter(
              (item) => String(item.id) !== String(action.payload.id),
            ),
          };
        }
      }

      return {
        ...state,
        logesalesitemDeleteByIdStatus: action.payload.success,
        logesalesorderdataList: updatedList, // स्टोर अपडेट करें
      };
    default:
      return state;
  }
}
